export default __webpack_public_path__ + "de1df834f4237cae19fee86ae5d8d8af.png";